import React from 'react';

const LoadingSpinner = ({ size = 'large', text = 'Loading...' }) => {
  const sizeClasses = {
    small: 'w-6 h-6 border-2',
    medium: 'w-10 h-10 border-3',
    large: 'w-16 h-16 border-4'
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-64 w-full">
      <div className="relative">
        <div
          className={`${sizeClasses[size]} rounded-full border-primary-100 border-t-primary-500 animate-spin`}
        />
        <div
          className={`absolute inset-0 ${sizeClasses[size]} rounded-full border-secondary-100 border-b-secondary-500 animate-spin`}
          style={{ animationDirection: 'reverse', animationDuration: '1.5s' }}
        />
      </div>
      {text && (
        <p className="mt-4 text-primary-500 font-medium text-sm">{text}</p>
      )}
    </div>
  );
};

export const FullPageSpinner = () => (
  <div className="fixed inset-0 flex items-center justify-center bg-white z-50">
    <div className="flex flex-col items-center">
      <div className="w-20 h-20 rounded-full border-4 border-primary-100 border-t-primary-500 animate-spin mb-4" />
      <div className="text-center">
        <h3 className="text-primary-500 font-serif font-bold text-xl">Bhujauli English School</h3>
        <p className="text-gray-500 text-sm mt-1">Loading...</p>
      </div>
    </div>
  </div>
);

export default LoadingSpinner;
